module.exports = __webpack_public_path__ + "media/slider/Banner-11-79763491.jpg";